import { Component, ChangeDetectionStrategy, HostBinding, computed, input } from '@angular/core';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { BETA_SERVICE_STACK_TYPES } from '@zerops/models/service-stack';
import { ZuiTagModule } from './tag.module';

/**
 * Beta marker of a service type. Self-gating: renders (and takes space)
 * only when the given service stack type is in beta.
 */
@Component({
  selector: 'zui-beta-tag',
  template: `
    @if (isBeta()) {
      <zui-tag class="__tag  tag--warning" [matTooltip]="hint">beta</zui-tag>
    }
  `,
  styleUrl: './beta-tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ MatTooltipModule, ZuiTagModule ]
})
export class ZuiBetaTagComponent {
  serviceStackTypeId = input<string>();

  isBeta = computed(() => {
    const id = this.serviceStackTypeId();
    return !!id && BETA_SERVICE_STACK_TYPES.has(id);
  });

  @HostBinding('class.is-hidden')
  get isHidden() {
    return !this.isBeta();
  }

  hint = 'This service type is in beta: behaviour and APIs can change without notice.';
}
